import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Подберем любой транспорт на хороших условиях',
  description:
    'Просто расскажите нам, какая техника или автомобиль вам необходимы, и мы подберем для вас транспорт в кратчайшие сроки и по выгодной цене.<br> Автопроизводители и дилеры предоставляют ВТБ Лизинг специальные условия приобретения корпоративных автомобилей.',
  offerButton: 'Подать заявку',
  popularMarks: { label: 'Популярные марки в рамках предложения:' },
} satisfies TMessages
